import { render, staticRenderFns } from "./component-item.vue?vue&type=template&id=48156f50&scoped=true&"
import script from "./component-item.vue?vue&type=script&lang=ts&"
export * from "./component-item.vue?vue&type=script&lang=ts&"
import style0 from "./component-item.vue?vue&type=style&index=0&id=48156f50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48156f50",
  null
  
)

export default component.exports